module.exports = __webpack_public_path__ + "img/lock.7b126b14.svg";